import React from 'react'
import PropagateLoader from "react-spinners/PropagateLoader";
function Loader() {
  return (
    <section class="loading-container">
        <PropagateLoader color="#143566" />
      </section>
  )
}

export default Loader